<!--用户管理-->
<template>
    <div>
        <!--顶部搜索-->
        <el-row class="box">
            <el-form :size="size">
                <el-col :span="2"><el-form-item label="产品分类用户数" prop="id"></el-form-item></el-col>
                <el-col :span="20">
                    <el-badge v-for="(item) in countList" :value="item.count" :key="item.categoryId" class="item">
                        <el-button :class="item.class" :size="size" @click="getUsersList1(item.categoryId)">{{item.categoryName}}</el-button>
                    </el-badge>
                </el-col>
            </el-form>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
            <el-form :model="queryInfo" ref="queryInfoRef" :size="size">
                <el-col :span="3">
                    <user-type :size="size" :value="queryInfo.type" @updateUsertype="getUsertype" ></user-type>
                </el-col>
                <el-col :span="3">
                    <AreaCascader :size="size" @nodeChange="nodeAreaCascader" ></AreaCascader>
                </el-col>
                <el-col :span="3">
                    <RoleSecect :size="size" :value="queryInfo.roleId" @updateRoleId="handleUpdateRoleId1" ></RoleSecect>
                </el-col>
                <el-col :span="3">
                    <PositionSelect :size="size" :value="queryInfo.positionId" @updatePositionId="handleUpdatePosition"></PositionSelect>
                </el-col>
                <el-col :span="3">
                    <el-input :size="size" placeholder="请输入手机号" v-model="queryInfo.mobile" clearable ></el-input>
                </el-col>
                <el-col :span="5">
                    <el-date-picker :size="size" style="width: 90%;" value-format="yyyy-MM-dd"
                                    v-model="time"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :picker-options="pickerOptions">
                    </el-date-picker>
                </el-col>
                <el-col :span="4" style="padding-left: 0px;">
                    <el-button :size="size" v-permission="['SYS-USER-QUERY']" type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
                <!--</el-col>
                <el-col :span="2">-->
                    <el-button :size="size" type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
                    <el-button :size="size" v-permission="['SYS-USER-CREATE']" type="primary" icon="el-icon-plus" @click="showAddUserDialog">添加用户</el-button>
                </el-col>
                <el-col :span="2" style="text-align: right;">
                    <!--v-if="checkPer(['',''])"-->

                </el-col>
            </el-form>
        </el-row>
        <!--内容展示-->
        <el-row :gutter="20" style="margin-top: 20px;" class="row-box">
            <!--部门-->
            <el-col :span="3">
                <el-card shadow="hover" class="el-card" :style="objstyle">
                    <el-row>
                        <el-col :span="12">组织机构</el-col>
                        <el-col :span="3" :offset="1">
                            <i class="el-icon-edit" @click="toDepart" style="cursor:pointer"></i>
                        </el-col>
                        <el-col :span="3">
                            <i style="cursor:pointer" :class="departmentExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="departmentExpanded=!departmentExpanded"></i>
                        </el-col>
                        <el-col :span="3">
                            <i style="cursor:pointer" class="el-icon-refresh" @click="refresh"></i>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <Department :key="timer" :expand="departmentExpanded" @nodeData="handleDepartmentData" @checkChange="handleNodeDepartmentCheck" @nodeChange="handleNodeDepartmentClick"></Department>
                </el-card>
            </el-col>
            <!--树形表格-->
            <el-col :span="21">
                <el-table v-loading="loading" ref="tableRef" border stripe checkBox :height="treeTableHeight" :data="tablelist" >
                    <template v-for="(v,k) in columns">
                        <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-if="v.prop==='gender'">
                            <template slot-scope="scope">
                                <i class="el-icon-male" v-if="scope.row.gender === 1" style="color: lightblue"></i>
                                <i class="el-icon-female" v-if="scope.row.gender === 0" style="color: red"></i>
                                <i class="el-icon-user" v-else ></i>
                            </template>
                        </el-table-column>
                        <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='status'">
                            <template slot-scope="scope">
                                <el-tag type="danger" v-if="scope.row.status === 0" >停用</el-tag>
                                <el-tag type="success" v-if="scope.row.status === 1" >正常</el-tag>
                                <el-tag type="warning" v-else >密码过期</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='roleId'">
                            <template slot-scope="scope">
                                <el-tag size="mini" >{{scope.row.roleName}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='departmentId'">
                            <template slot-scope="scope">
                                <el-tag size="mini" >{{scope.row.departmentName}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.prop==='positionId'">
                            <template slot-scope="scope">
                                <el-tag size="mini" >{{scope.row.positionName}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else-if="v.label==='操作'">
                            <template slot-scope="scope"><!-- -->
                                <el-button v-permission="['SYS-USER-DETAIL']" type="info" size="mini" icon="el-icon-info" round @click="showInfoDialog(scope.row)">详情</el-button>
                                <el-button v-permission="['SYS-USER-UPDATE','SYS-USER-OTHER-INFO']" type="primary" size="mini" icon="el-icon-edit" round @click="showEditDialog(scope.row.uid)">编辑</el-button>
                                <el-button v-permission="['SYS-USER-SELECT-SCOPE']" type="warning" size="mini" icon="el-icon-edit" round @click="showScopeDialog(scope.row)">数据范围</el-button>
                                <el-button v-permission="['SYS-USER-DELETE']" type="danger" size="mini" icon="el-icon-delete" round @click="deleteEditDialog(scope.row.uid)">删除</el-button>
                                <el-button type="success" size="mini" icon="el-icon-edit" round @click="checkEditDialog(scope.row.uid)">智能安检</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column :type="v.type" :label="v.label" :fixed="v.fixed" :key="k" :prop="v.prop" :width="v.width" v-else></el-table-column>
                    </template>
                    <!--<template slot="isok" slot-scope="scope">
                        <i class="el-icon-success" v-if="scope.row.cat_deleted === false" style="color: lightgreen"></i>
                        <i class="el-icon-error" v-else style="color: red"></i>
                    </template>
                    <template slot="order" slot-scope="scope">
                        <el-tag size="mini" v-if="scope.row.cat_level === 0">一级</el-tag>
                        <el-tag size="mini" v-else-if="scope.row.cat_level === 1" type="success">二级</el-tag>
                        <el-tag size="mini" v-else type="warning">三级</el-tag>
                    </template>
                    <template slot="opt" slot-scope="scope">
                        <el-button type="primary" size="min" icon="el-icon-edit" circle @click="showEditDialog(scope.row.cat_id)">编辑</el-button>
                        <el-button type="danger" size="min" icon="el-icon-delete" circle @click="deleteEditDialog(scope.row.cat_id)">删除</el-button>
                    </template>-->
                </el-table>
                <!--分页区域-->
                <Pagination v-if="total>0" :total="total" :page="queryInfo.pagenum" :limit="queryInfo.pagesize" @updatePage="handleCurrentChange" @updateLimit="handleSizeChange" ></Pagination>
            </el-col>
        </el-row>
        <!--添加用户弹框-->
        <div v-if="userAddDialogVisible">
            <el-dialog :title="titleForm"
                       :visible.sync="userAddDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true"
                       width="50%"
                       @close="handleCloseAddUser">
                <el-form :model="addUserForm" :rules="addUserFormRules" ref="addUserFormRef" label-width="100px">
                    <el-row>
                        <el-col :span="12" v-if="userAddShow">
                            <el-form-item label="用户名：" prop="userName">
                                <el-input v-model="addUserForm.userName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="userAddShow">
                            <el-form-item label="密码：" prop="password">
                                <el-input v-model="addUserForm.password"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="userAddShow">
                            <el-form-item label="手机号：" prop="mobile">
                                <el-input v-model="addUserForm.mobile"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="角色：" prop="roleId">
                                <RoleSecect v-model="addUserForm.roleId" @updateRoleId="handleUpdateRoleId"></RoleSecect>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="部门：" prop="departmentId">
                                <DepartmentCascader v-model="addUserForm.departmentId" @nodeChange="nodeDepartmentCascader"></DepartmentCascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="职位：" prop="positionId">
                                <el-select clearable v-model="addUserForm.positionId" placeholder="请选择职位" style="width: 100%;"><!--@change="changePosition"-->
                                    <el-option
                                            v-for="item in positionList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="真实姓名：" prop="realName">
                                <el-input v-model="addUserForm.realName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="用户类型：" prop="type">
                                <UserType v-model="addUserForm.type" @updateUsertype="getUsertype1"></UserType>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button type="primary" @click="addUserFun">确 定</el-button>
                </span>
            </el-dialog>

        </div>
        <!--用户设备列表-->
        <div v-if="upDialogVisible">
            <el-dialog title="用户设备列表"
                       :visible.sync="upDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true"
                       width="80%"
                       @close="handleCloseUP">
                <UP :upitem="upItem"></UP>
            </el-dialog>
        </div>
        <div v-if="scopeDialogVisible">
            <el-dialog title="数据范围"
                       :visible.sync="scopeDialogVisible"
                       :close-on-click-modal="false"
                       :close-on-press-escape="false"
                       :destroy-on-close="true"
                       width="40%"
                       @close="handleCloseScope">
                <el-form :model="scopeForm" ref="scopFormRef" label-width="100px">
                    <el-row>
                        <el-form-item label="部门：" prop="departmentId">
                            <DepartmentCascader :value="departmentId" @nodeChange="nodeDepartmentCascaderData"></DepartmentCascader>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="权限：" prop="permissionId">
                            <el-select multiple v-model="permissionId" style="width: 100%;">
                                <el-option v-for="item in permissions"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="范围：" prop="scope">
                            <el-select v-model="scope" style="width: 100%;">
                                <el-option v-for="item in dataScopes"
                                           :key="item.value"
                                           :label="item.label"
                                           :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row v-if="scope==2">
                        <el-form-item label="表达式：" prop="expression">
                            <el-input v-model="expression"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-col :span="2">
                            <el-form-item label="" prop="">
                                <el-button icon="el-icon-circle-plus-outline" @click="addScope">添加数据范围</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-tag
                                v-for="(tag,index) in scopes"
                                :key="index"
                                closable
                                @close="handleTagClose(index, tag)" style="margin: 10px 10px 10px 0;">
                            {{reversedMessage(tag)}}
                        </el-tag>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="addUserScope">确 定</el-button>
            </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/pagination'
import AreaCascader from '@/components/areaCascader'
import Department from '@/components/department'
import DepartmentCascader from '@/components/department/cascader'
import RoleSecect from '@/components/roleSelect/RoleSecect'
import UserType from '@/components/userType'
import PositionSelect from '@/components/positionSelect/Index'
import { userList, userAdd, delUser, getInfoElse, updateUser,
    getScope, getScopeLogin, addScope, getCountByCategory } from '@/api/user'
import { getPositionPage } from '@/api/position'
import {checkMobile, isPassword, validateCode} from '@/utils/rule'
import bus from '@/utils/eventBus'
import UP from '@/views/index/up/Index'
// samePwd,
let list1 = []
export default {
    name: 'SYS-USER',
    /*activated(){
        console.log('用户 activated')
    },*/
    components: {
        Pagination, AreaCascader, Department, DepartmentCascader, RoleSecect, UserType, PositionSelect,UP
    },
    data() {
        return {
            tablelist: [],
            columns: [
                {
                    label: '昵称',
                    prop: 'nickName',
                    //width: '280px',
                    fixed: 'left'
                },{
                    label: '手机号',
                    prop: 'mobile',
                    width: '180px'
                },{
                    label: '角色',
                    type: 'template',
                    prop: 'roleId',
                    width: '100px'
                },{
                    label: '部门',
                    type: 'template',
                    prop: 'departmentId',
                    width: '100px'
                },{
                    label: '职位',
                    type: 'template',
                    prop: 'positionId',
                    width: '100px'
                },{
                    label: '性别',
                    type: 'template',
                    prop: 'gender',
                    width: '60px'
                },{
                    label: '状态',
                    type: 'template',
                    prop: 'status',
                    width: '80px'
                }/*,{
                    label: '创建时间',
                    prop: 'createTime',
                    hide: true
                }*/,{
                    label: '操作',
                    type: 'template',
                    prop: 'action',
                    width: '480px',
                    fixed: 'right'
                }
            ],
            time:[],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            queryInfo: {
                pagesize: 10,
                pagenum: 1,
                mobile: '',
                type: null,
                // typetitle: '请选择',
                provinceCode: '',
                cityCode: '',
                areaCode: '',
                communityCode: '',
                roleId: '',
                departmentId: null,
                positionId: '',
                department: null
            },
            total: [],
            treeTableHeight: 650,
            objstyle: {
                height: '150px'
            },
            departmentExpanded: false,
            userAddDialogVisible: false,
            addUserForm: {
                userName: '',
                password: '',
                mobile: '',
                roleId: '',
                departmentId: 1,
                positionId: '',
                realName: '',
                nickName: '',
                type: '2',// typetitle: '系统用户',
                uid: ''
            },
            addUserFormRules: {
                userName: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                    { validator: validateCode, trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: checkMobile, trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { validator: isPassword, trigger: 'blur' }
                ],
                roleId: [
                    { required: true, message: '请选择角色', trigger: 'change' }
                ],
                departmentId: [
                    { required: true, message: '请选择部门', trigger: 'change' }
                ],
                /*positionId: [
                    { required: true, message: '请选择职位', trigger: 'change' }
                ],*/
                realName: []
            },
            departmentList: [],
            positionList: [],
            dataScopes: [
                {value:1,label:'仅本人数据权限'},
                {value:2,label:'自定义数据权限'},
                {value:3,label:'本部门数据权限'},
                {value:4,label:'本部门及以下数据权限'},
                {value:5,label:'所有数据权限'}
            ],
            userAddShow: true,
            titleForm: '添加用户',
            /*下面信息是up列表相关*/

            upDialogVisible: false,
            upItem:{
                uid: '',
                type: 1
            },
            scopeDialogVisible: false,
            departmentId: 0,
            // departmentName: '',
            expression: '',
            permissionId: [],
            permissionName: '',
            permissions: [],
            scope: 1,
            uid: 0,
            scopeForm: {

            },
            // 存放数据范围值
            scopes: [],
            scopeObj: {},
            // 登录用户数据范围
            scopesLogin: [],
            bumendata: [],
            timer: 0,
            size:this.COMMON.size,
            countList:[],
            loading: true
        }
    },
    methods: {
        clearArea(){
            this.queryInfo.provinceCode=null
            this.queryInfo.cityCode=null
            this.queryInfo.areaCode=null
            this.queryInfo.communityCode=null
            // console.log('执行了 clearArea')
        },
        getUsertype(val) {
            this.queryInfo.type = val
            // console.log(this.queryInfo.type)
        },
        getUsertype1(val) {
            this.addUserForm.type = val
            // console.log(this.addUserForm.type)
        },
        /**
         * 区域级联菜单change事件处理
         * @param val
         */
        nodeAreaCascader(val,label) {
            if(val.length==0){
                this.clearArea()
            }else{
                this.queryInfo.address = val[2]
                if(val.length>=1){
                    this.queryInfo.provinceCode = val[0]
                }
                if(val.length>=2){
                    this.queryInfo.cityCode = val[1]
                }
                if(val.length>=3){
                    this.queryInfo.areaCode = val[2]
                }
                if(val.length>=4){
                    this.queryInfo.communityCode = val[3]
                }
            }
            console.log(this.queryInfo,label)
        },
        /**
         * 分页组件切换分页大小事件处理
         * @param newSize
         */
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize
            this.getUsersList()
        },
        /**
         * 分页组件切换页事件处理
         * @param newPage
         */
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage
            this.getUsersList()
        },
        /**
         * 部门树形组件展开/折叠事件处理
         * @param val
         */
        handleNodeDepartmentClick(val) {
            // console.log(val)
            this.queryInfo.departmentId = val
            this.getUsersList()
        },
        // 部门树形组件选中事件
        handleNodeDepartmentCheck(val, checked) {
            if(checked) {
                if(this.queryInfo.department.indexOf(val)==-1){
                    this.queryInfo.department.push(val)
                }
            }else {
                if(this.queryInfo.department.indexOf(val)>-1){
                    this.queryInfo.department.splice(this.queryInfo.department.indexOf(val), 1);
                }
            }
            // console.log(this.queryInfo.department)
        },
        handleDepartmentData(val){
            this.bumendata = val
            this.departmentId = this.bumendata[0].id

            let arr = this.scopesLogin.filter(item=>{
                return item.departmentId === this.departmentId
            })
            if(arr.length>0){
                this.permissions = arr[0].permissions
            }
        },
        toDepart(){
            bus.$emit('share', {name: 'SYS-DEPARTMENT', label: '部门管理'})
        },
        getUsersList1(id){
            this.queryInfo.pagenum = 1
            for (let i = 0; i < this.countList.length; i++) {
                if(this.countList[i].categoryId===id){
                    this.countList[i].class='el-badge_el-button_click'
                }else{
                    this.countList[i].class=''
                }
            }
            this.queryInfo.categoryId=id
            this.getUsersList()
        },
        // 获取用户列表
        getUsersList(){
            this.tablelist = list1
            this.total = list1.length
            /*if(id!=undefined){
            }*/
            //console.log('time',this.time)
            let param = {}
            let user = {
                mobile: this.queryInfo.mobile.trim(),
                type: this.queryInfo.type,
                provinceCode: this.queryInfo.provinceCode,
                cityCode: this.queryInfo.cityCode,
                areaCode: this.queryInfo.areaCode,
                communityCode: this.queryInfo.communityCode,
                departmentId: this.queryInfo.departmentId,
                roleId: this.queryInfo.roleId,
                categoryId: this.queryInfo.categoryId,
                positionId: this.queryInfo.positionId
            }
            if(this.time!=null){
                user.startDate=this.time[0]
                user.endDate=this.time[1]
            }
            param.current = this.queryInfo.pagenum
            param.size = this.queryInfo.pagesize
            console.log('用户条件',user)
            this.loading = true
            userList(param,user).then(response => {
                // console.log('用户列表',response.data)
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                this.tablelist = response.data.records
                this.total = response.data.total
                this.loading = false
            })
        },
        getHeight() {
            // console.log(window.innerHeight)
            this.objstyle.height = window.innerHeight - 60 -40 -55 -70 -40 -20 -10 + 'px'
            this.treeTableHeight = window.innerHeight - 60 -40 -55 -70 -40 -20 -33 + 'px'
        },
        // 展示用户添加
        showAddUserDialog(){
            this.titleForm = '添加用户'
            this.userAddShow = true
            this.userAddDialogVisible = true
            this.addUserForm.userName = ''
            this.addUserForm.mobile = ''
            this.getPosition()
        },
        // 关闭用户添加
        handleCloseAddUser() {
            this.$refs.addUserFormRef.resetFields()
            this.userAddDialogVisible = false
        },
        // 角色切换事件
        handleUpdateRoleId(val) {
            // console.log('角色切换-添加用户',val)
            this.addUserForm.roleId = val
        },
        handleUpdateRoleId1(val) {
            // console.log('角色切换-查询用户',val)
            this.queryInfo.roleId = val
        },
        // 部门级联切换事件
        nodeDepartmentCascader(val) {
            // console.log('选择的部门id:' + val)
            // val = 1级id, 2级id, 3级id....
            // var vals = val.split(',')
            this.addUserForm.departmentId = val[val.length-1]
        },
        // 获取职位列表
        getPosition() {
            let param = {}
            param.current = 1
            param.size = 20
            getPositionPage(param,{}).then(response => {
                this.positionList = response.data.records
                // console.log(this.positionList)
            })
        },
        // 职位切换事件
        changePosition(val) {
            // console.log('选择的职位id:' + val)
            this.addUserForm.positionId = val
        },
        // 提交新用户
        addUserFun() {
            console.log('执行'+this.titleForm,this.addUserForm)
            this.$refs.addUserFormRef.validate(async valid => {
                if (!valid) return
                if(this.titleForm==='添加用户'){
                    this.addUserForm.nickName = this.addUserForm.userName
                    userAdd(this.addUserForm).then(response => {
                        // console.log('添加用户结果',response.data)
                        if(response.code!=200){
                            return this.$message.error('添加用户失败！')
                        }
                        this.$message.success('添加用户成功！')
                        this.getUsersList()
                        this.userAddDialogVisible = false
                    })
                }else if(this.titleForm==='编辑用户'){
                    updateUser(this.addUserForm).then(response => {
                        if(response.code!=200){
                            return this.$message.error('编辑用户失败！')
                        }
                        this.$message.success('编辑用户成功！')
                        this.getUsersList()
                        this.userAddDialogVisible = false
                    })
                }
            })
        },
        //up弹窗关闭事件
        handleCloseUP(){
            this.upDialogVisible = false
        },
        //用户详情
        showInfoDialog(item) {
            // bus.$emit('share', {name: 'SYS-USER-PROJECT', label: '用户项目',tabOnly:true})
            this.upItem.uid = item.uid
            this.upItem.type = item.type
            this.upDialogVisible = true
            // console.log('用户详情',item)
        },
        showEditDialog(uid) {
            this.titleForm = '编辑用户'
            this.userAddDialogVisible = true
            if(this.positionList.length ===0){
                this.getPosition()
            }
            getInfoElse(uid).then(response => {
                if(response.code === 200){
                    console.log('获取到用户信息',response.data)
                    this.addUserForm.uid = response.data.uid
                    this.addUserForm.userName = response.data.userName
                    this.addUserForm.password = ''
                    this.addUserForm.mobile = response.data.mobile
                    this.addUserForm.roleId = response.data.roleId
                    this.addUserForm.departmentId = response.data.departmentId
                    this.addUserForm.positionId = response.data.positionId
                    this.addUserForm.realName = response.data.realName
                    this.addUserForm.nickName = response.data.nickName
                    this.addUserForm.type = response.data.type.toString()
                    // this.addUserForm.typetitle = '系统用户'
                    if(response.data.scopes!=undefined){
                        this.addUserForm.scopes = response.data.scopes
                    }
                }
                this.userAddShow = false
            })
        },
        showScopeDialog(item){
            console.log(item)
            this.uid=item.uid
            getScope(item.uid).then(response => {
                // console.log('用户资源结果',response)
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                // console.log("===================="+JSON.stringify(response.data))
                this.scopes = response.data
                this.scopeDialogVisible = true
            })
        },
        async deleteEditDialog(uid) {
            const confirmResult = await this.$confirm('此操作将删除该用户及用户相关信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            // 如果用户确认删除，则返回值未字符串 confirm
            // 如果用户取消了删除，则返回值未字符串 cancel
            if (confirmResult !== 'confirm') {
                return this.$message.info('取消删除')
            }
            delUser(uid).then(response => {
                // console.log('删除用户结果',response)
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                this.getUsersList()
                this.$message.success(response.msg)
            })
        },
        addScope() {
            // 这里需要判断是否重复并给出提示
            // console.log(this.scopeObj[this.departmentId])
            // console.log(this.permissionId)
            if(this.permissionId.length>0&&this.departmentId!=null&&this.departmentId!=undefined){
                let permissions = []
                this.permissionId.forEach(value => {
                    this.scopesLogin.forEach(item=>{
                        item.permissions.forEach(item1=>{
                            if(item1.id === value){
                                permissions.push({id:value,name:item1.name})
                            }
                        })
                    })
                })
                let ishavedepart=false
                for (let i = 0; i < this.scopes.length; i++) {
                    if(this.departmentId===this.scopes[i].departmentId){
                        for (let j = 0; j <permissions.length; j++) {
                            let arr=this.scopes[i].permissions.filter(item=>item.id===permissions[j].id)
                            if(arr.length===0){
                                this.scopes[i].permissions.push(permissions[j])
                            }
                        }
                        ishavedepart=true
                    }
                }
                if(!ishavedepart){
                    this.scopes.push({
                        departmentId: this.departmentId,
                        permissions: permissions,
                        scope: this.scope,
                        uid: this.uid,
                        expression: ''
                    })
                }
            }else{
                this.$message.error('必须选择部门和权限！')
            }

            // this.scopeObj[this.departmentId][] =
            /*this.scopes.push({
                departmentId: this.departmentId,
                permissionId: this.permissionId,
                scope: this.scope,
                uid: this.uid
            })*/
        },
        handleTagClose(index, tag) {
            this.scopes.splice(index, 1)
            console.log('移除元素'+tag)
        },
        nodeDepartmentCascaderData(val,label) {
            console.log('部门回传',val,label)
            this.departmentId = val[val.length-1]
            // this.dataDepartmentName = label[val.length-1]
            let arr = this.scopesLogin.filter(item=>{
                return item.departmentId === val[0]
            })
            if(arr.length>0){
                this.permissions = arr[0].permissions
            }
            // console.log(this.permissions)
            this.permissionId = []
        },
        handleUpdatePosition(val){
            this.queryInfo.positionId = val
        },
        handleCloseScope() {
            this.$refs.scopFormRef.resetFields()
            this.scopeDialogVisible = false
        },
        scopeLogin(){
            getScopeLogin().then(response => {
                console.log('登录用户数据范围结果',response)
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                // console.log(response.data)
                this.scopesLogin = response.data
            })
        },
        getParentNode(data,id) {
            var hasFound = false, // 表示是否有找到id值
                result = {name: ''}
            var fn = function (data) {
                if (Array.isArray(data) && !hasFound) { // 判断是否是数组并且没有的情况下，
                    data.forEach(item => {
                        if (item.id === id) { // 数据循环每个子项，并且判断子项下边是否有id值
                            result = item // 返回的结果等于每一项
                            hasFound = true // 并且找到id值
                        } else if (item.child) {
                            fn(item.child) // 递归调用下边的子项
                        }
                    })
                }
            }
            fn(data) // 调用一下
            // console.log('父节点',result,id)
            return result
        },
        addUserScope(){
            // console.log('提交权限',this.scopes)
            addScope(this.scopes,this.uid).then(response => {
                if(response.code!=200){
                    return this.$message.error(response.msg)
                }
                console.log('addScope结果',response)
                this.$message.success(response.msg)
                this.scopeDialogVisible = false
            })
        },
        refresh(){
            this.timer = new Date().getTime()
        },
        resetQuery() {
            this.$refs.queryInfoRef.resetFields()
            this.queryInfo.mobile = ''
            this.queryInfo.type = null
            this.queryInfo.provinceCode = ''
            this.queryInfo.cityCode = ''
            this.queryInfo.areaCode = ''
            this.queryInfo.communityCode = ''
            this.queryInfo.roleId = ''
            this.queryInfo.departmentId = null
            this.queryInfo.positionId = ''
            this.queryInfo.department = null
            this.queryInfo.pagenum = 1
            this.queryInfo.categoryId = ''
            this.time=null
            // console.log('重置后',this.queryInfo)
            for (let i = 0; i < this.countList.length; i++) {
                this.countList[i].class=''
            }
            this.getUsersList()
        },
        checkEditDialog(uid){
            bus.$emit('share', {
                name: 'BUSINESS-CHECK',
                label: '智能安检',
                path:'/check',
                query:{
                    checkUid:uid
                }
            })
        },
        getCount(){
            getCountByCategory().then(response => {
                if (response.code != 200)
                    return this.$message.error('获取各产品分类用户数失败！')
                this.countList = response.data
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryInfo.pagenum = 1
            this.getUsersList()
        }
    },
    computed: {
        reversedMessage() {
            return function (scope) {
                // console.log('scope格式化',scope)
                var scopename = this.dataScopes.find((value) => {
                    // console.log(index, arr) , index, arr
                    return value.value === scope.scope
                })
                let permissionArr=[]
                scope.permissions.forEach((item) => {
                    permissionArr.push(item.name)
                })
                // console.log('scopename',scopename)
                // console.log(this.bumendata)
                return this.getParentNode(this.bumendata,scope.departmentId).name + ' '+JSON.stringify(permissionArr)+' ('+scopename.label+')'
            }
        }
    },
    created() {
        this.getHeight()
        window.addEventListener('resize', this.getHeight)
        this.getUsersList()
        this.scopeLogin()
        this.getCount()
    },
    destroyed() {
        window.removeEventListener('resize', this.getHeight)
    },
    activated(){
        this.$refs.tableRef.doLayout()
    }
}
</script>

<style lang="scss" scoped>
.row-box {
    display: flex;
    flex-flow: wrap;
}
/*.row-box .el-card {
    height: 100%
}*/
.el-card ::v-deep {
    .el-card__body{
        height: calc(100% - 40px)!important;
    }
}
.item {
    /*margin-top: 10px;*/
    margin-right: 40px;
}
/*.box >>> .el-form-item {
    margin-bottom: 0px!important;
}*/
.el-divider--horizontal {
    margin: 0px 0px 20px;
}
.el-badge_el-button_click {
    color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
</style>
